export const SET_TRANSACTION_DETAILS = "SET_TRANSACTION_DETAILS";
export const RESET_TRANSACTION_REDUCER = "RESET_TRANSACTION_REDUCER";
export const SET_EDIT_DATA = "SET_EDIT_DATA";
export const RESET_EDIT_DATA = "RESET_EDIT_DATA";